module.exports = __webpack_public_path__ + "img/diamonds-3-new.e1c7bb6a.svg";